import { SERVICE_STATUS } from './service-status.model';

// HR
export enum HR_SERVICE_STEP {
  CREDIT_PENDING = 'CREDIT_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDITED = 'CREDITED',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  GAVE_UP = 'GAVE_UP',
  RENEGOTIATING = 'RENEGOTIATING',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  RESTRUCTURED = 'RESTRUCTURED',
}

export type HrServiceStatusByStepMap = { [property in HR_SERVICE_STEP]: SERVICE_STATUS[] };

export const HR_SERVICE_STATUS_BY_STEP: HrServiceStatusByStepMap = {
  CREDIT_PENDING: [
    SERVICE_STATUS.CNAB_PENDING,
    SERVICE_STATUS.CREDIT_PENDING,
    SERVICE_STATUS.ENDORSEMENT_CREATED,
  ],
  CREDIT_ERROR: [SERVICE_STATUS.CREDIT_ERROR, SERVICE_STATUS.PIX_PROCESSING_ERROR],
  CREDITED: [SERVICE_STATUS.IN_PROGRESS],
  EXPIRED: [SERVICE_STATUS.EXPIRED],
  FINISHED: [SERVICE_STATUS.FINISHED],
  GAVE_UP: [SERVICE_STATUS.GAVE_UP],
  RENEGOTIATING: [SERVICE_STATUS.RENEGOTIATING],
  PENDING_PAYMENT: [SERVICE_STATUS.DEFAULT, SERVICE_STATUS.PIX_PROCESSING],
  RESTRUCTURED: [SERVICE_STATUS.RESTRUCTURED],
};

// EMPLOYEE
export enum EMPLOYEE_SERVICE_STEP {
  CREDIT_PENDING = 'CREDIT_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDITED = 'CREDITED',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  GAVE_UP = 'GAVE_UP',
  RENEGOTIATING = 'RENEGOTIATING',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  RESTRUCTURED = 'RESTRUCTURED',
}

export type EmployeeServiceStatusByStepMap = {
  [property in EMPLOYEE_SERVICE_STEP]: SERVICE_STATUS[];
};

export const EMPLOYEE_SERVICE_STATUS_BY_STEP: EmployeeServiceStatusByStepMap = {
  CREDIT_PENDING: [
    SERVICE_STATUS.CNAB_PENDING,
    SERVICE_STATUS.CREDIT_PENDING,
    SERVICE_STATUS.ENDORSEMENT_CREATED,
  ],
  CREDIT_ERROR: [SERVICE_STATUS.CREDIT_ERROR],
  CREDITED: [SERVICE_STATUS.IN_PROGRESS],
  EXPIRED: [SERVICE_STATUS.EXPIRED],
  FINISHED: [SERVICE_STATUS.FINISHED],
  GAVE_UP: [SERVICE_STATUS.GAVE_UP],
  RENEGOTIATING: [SERVICE_STATUS.RENEGOTIATING],
  PENDING_PAYMENT: [SERVICE_STATUS.DEFAULT],
  RESTRUCTURED: [SERVICE_STATUS.RESTRUCTURED],
};
